<template functional>
  <svg v-bind="data.attrs"
       :class="data.staticClass"
       :style="{height: props.height || '', width: props.width || '', ...data.staticStyle}"
       xmlns="http://www.w3.org/2000/svg">
    <use :xlink:href="'#' + props.name"></use>
  </svg>
</template>

<script>
  export default {
    props: [
      'height',
      'width',
      'name'
    ]
  }
</script>

<style lang="less">

</style>
